export { default as Component } from "./Group.svelte";
export const modes = ["static"];
